const utils = require('../../../lib/utils')

module.exports = {
	extends: [
		'/',
		'base',
		'form',
		'form'
	],

	config: {
		checkForBrowserFills: true,
		isLoginDialog: false,
		resetDirtyFieldsAfterSuccessfulSubmit: false,
		onSubmitDonePanelMessage: '',
		statusControllerLoadingMessage: '',
		statusControllerSavingMessage:  'status.progress.login',
		submitEventDefaultsGranted: true,

		resourceUrl: '/~/login',
		preventIDSelector: true,

		// credentialOptions: { // overrule some options used by credentialsManager.
		// 	forwardUrlScope: 'default', // overrule used forwardUrlScope.
		// }
	},

	events: {
		show: {
			type: 'click',
			selector: 'button',
			action(event){
				const self = event.data.component
				const $target = $(event.target).closest('button')
				if($target.length > 0){
					const buttonContext = $target.data('buttonContext')

					if(buttonContext === 'credentials'){
						const fieldType = $target.data('fieldType')

						if(fieldType === 'showReLogin' || fieldType === 'showReset' || fieldType === 'showRegister'){
							self.show(buttonContext, fieldType)
						}
					}
				}
			}
		}

	},

	methods: {

		/**
		 * this function is used to handle the different kinds of errors.
		 * NOTE: if this function returns reject no error occurred (e.g., if the statusCode is 200)
		 * NOTE: if this function resolves the given context is allways the original context and NOT the error handling context.
		 *
		 * @param   context             object - action perform context
		 *          {
	     *              component: ...
	     *              [action]: ...
	     *              error: {
	     *                  statusCode: <statusCode>            mixed - status code || 'clientError'
	     *                  name: <statusCode>                  string - error name
	     *                  errorCode: <statusCode>             string - error code
	     *                  message: <statusCode>               string - error message
	     *                  details: <statusCode>               string - error details
	     *                  [childErrors]: []                   [] - list of child errors
	     *              },
	     *              errorHandlingType: CONSTANTS.ERROR.HANDLING_TYPE[...]
		 *                                      int - this error handling type defines the state of error handling
	     *                                      e.g., has this error been thrown during error handling or has this error been thrown during custom error handling etc.
	     *                                      NOTE: this flag will be filled by CONSTANTS.ERROR.HANDLING_TYPE
	     *          }
		 * @returns Promise
		 */
		handleError: function(context){
			const baseError = utils.extractBaseError(context.error);
			let messageKey = false

			if(baseError.statusCode == 403){
				if(
					baseError.errorCode === 'USERMANAGEMENT_PROVIDER_LOGIN_ERROR_1'
					||
					baseError.errorCode === 'USERMANAGEMENT_PROVIDER_LOGIN_ERROR_2'
					||
					baseError.errorCode === 'USERMANAGEMENT_PROVIDER_LOGIN_ERROR_3'
					||
					baseError.errorCode === 'USERMANAGEMENT_PROVIDER_LOGIN_ERROR_4'
					||
					baseError.errorCode === 'USERMANAGEMENT_PROVIDER_LOGIN_ERROR_5'
					||
					baseError.errorCode === 'USERMANAGEMENT_PROVIDER_PIN_LOGIN_ERROR_1'
					||
					baseError.errorCode === 'USERMANAGEMENT_PROVIDER_PIN_LOGIN_ERROR_2'
					||
					baseError.errorCode === 'LOCAL_USERMANAGEMENT_PROVIDER_LOGIN_ERROR'
					||
					baseError.errorCode === 'USERMANAGEMENT_PROVIDER_SCOPEROLE_PREPARE_ERROR_1'
					||
					baseError.errorCode === 'USERMANAGEMENT_PROVIDER_MANDATORY_SCOPE_MISSING_ERROR_1'
					||
					baseError.errorCode === 'SHADOW_COMPONENT_NOT_GRANTED'
				){
					messageKey = 'error:login.invalidUserData'
				}
			}
			else if(baseError.statusCode == 400){
				if(baseError.errorCode === 'USERMANAGEMENT_LOGIN_PARAMETER_ERROR'){
					messageKey = 'error:login.inCompleteUserData'
				}
			}
			else if(baseError.statusCode == 500){
				if(
					baseError.errorCode === 'CREDENTIALS_ROUTE_INVALID_TYPE'
					||
					baseError.errorCode === 'CREDENTIALS_ROUTE_ERROR'
				){
					messageKey = 'error:login.credentialsError'
				} else if(
					baseError.errorCode === 'LOGIN_INVALID_MAIL_ERROR'
				){
					messageKey = 'error:login.invalidMail'
				} else if(
					baseError.errorCode === 'LOGIN_EMPTY_PASSWORD_ERROR'
				){
					messageKey = 'error:login.emptyPassword'
				}
			}

			if(messageKey){
				return this.performAction(
					this.prepareAction('message', undefined, {
						messageDisplay: {
							message: messageKey
						}
					}, {
						rollbackContext: context,
						statusControllerLoadingMessage: '',
						statusControllerSavingMessage:  ''
					})
				);
			}

			context.errorUnhandled = true;
			return utils.promise.resolve(context);
		},

		async show(buttonContext, fieldType){
			const baseActionKey = `${buttonContext}.${fieldType}`
			const actionKey = `${baseActionKey}_inEffect`
			return this.performAndStoreAction(
				actionKey,
				this.prepareAction(baseActionKey, undefined, undefined, undefined),
				true
			)
		},

		/**
		 * this function will be called after the response of a submit request has returned.
		 *
		 * @param   response        object - server response
		 */
		onSubmit: function(response){
			store.set(response)

			if(this.config.isLoginDialog){
				if(storage.user.data.states.authenticated){
					this.reperformRegisteredActions('relogin')
						.always(() => {
							storage.componentTree.callHandler(this, 'onSuccessfulLoginDialog');
						})
				}
			}
			else if(String(this.config.resourceUrl).match(/(\~\/)?login/) !== null){
				window.location.href = window.location.href;
			}
		},

		onAttachDone(attachTriggerOptions){
			if(!attachTriggerOptions.refresh){
				let activationData = false
				this.locate('< base_form_credentials_container > base_form_credentials_activationDataHandler', activationDataHandler => {
					activationData = activationDataHandler.model.activationData
				})

				let refresh = false
				const namedFields = this.model.namedFields || {}

				const userAttributes 	= (activationData || {}).userAttributes || {}
				const operations 		= (activationData || {}).operations || {}
				if(operations.autoFillLoginForm && namedFields.user && namedFields.password){
					if(userAttributes.code) 	this.fieldToModel('user', userAttributes.code);
					if(userAttributes.password) this.fieldToModel('password', userAttributes.password);
					refresh = true
				}

				if(utils.collectionSize(this.config.credentialOptions) > 0 && namedFields.credentialOptions){
					this.fieldToModel('credentialOptions', this.config.credentialOptions);
				}

				if(refresh){
					this.refresh(false)
				}
			}
		},

		async customSubmit(body){
			if(utils.isEmpty(((body || {}).data || {}).attributes)){
				await this.performAction(
					this.prepareAction('message', undefined, {
						messageDisplay: {
							message: 'error:login.emptyData'
						}
					}, {
						statusControllerLoadingMessage: '',
						statusControllerSavingMessage:  ''
					})
				);

				return utils.promise.reject()
			}
			return this.performAction(this.prepareAction('submit', undefined, undefined, {
				source: {
					submit: {
						data: body
					}
				}
			}))
		}
	},

	hooks: {
		async onDecision($element, options){
			await this.submit()
			await options.decisionComponent.hide()
		}
	},

	handlers: [
		{
			name: 'onSuccessfulLoginDialog',
			handle: function(callerComponent){
				this.triggerClosest('onDecision', {
					decisionComponent: this,
					decisionType: 'cancel'
				});
			}
		}
	]
};
